/**
 * MoftakiAI Icon — custom AI assistant icon from /moftakiai-icon.png.
 */
interface Props {
  size?: number;
}

export const MoftakiBotIcon = ({ size = 20 }: Props) => (
  <img src="/moftakiai-icon.png" alt="MoftakiAI" width={size} height={size}
    style={{ borderRadius: size > 24 ? 8 : 4, objectFit: 'cover' }} />
);
